module.exports = __webpack_public_path__ + "static/img/jump.b828f8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jump.jpg
// module id = VFTP
// module chunks = 3